import {Component, OnInit, Input} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-search-grants-listing',
  templateUrl: './search-grants-listing.component.html',
  styleUrls: ['./search-grants-listing.component.scss'],
  standalone: false
})
export class SearchGrantsListingComponent implements OnInit {

  @Input()
  rows: any[] = [];

  @Input()
  loadingData: boolean = false;

  sortedDescRecipientOfGrant: boolean = false;
  sortedDescCity: boolean = false;
  sortedDescCashGrantAmt: boolean = false;

  //Needs pop up for Grant Limit on creation
  constructor(private authService: AuthService, private apiService: ApiService,
              private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
  }

  sortTextRecipientOfGrantName(): void {
    if (!this.sortedDescRecipientOfGrant) {
      this.rows = this.apiService.sortTextDesc('recipientOfGrantName', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('recipientOfGrantName', this.rows)
    }
    this.sortedDescRecipientOfGrant = !this.sortedDescRecipientOfGrant
  }

  sortTextCity(): void {
    if (!this.sortedDescCity) {
      this.rows = this.apiService.sortTextDesc('recipientOfGrantCity', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('recipientOfGrantCity', this.rows)
    }
    this.sortedDescCity = !this.sortedDescCity;
  }

  sortNumberCashGrantAmt(): void {
    if (!this.sortedDescCashGrantAmt) {
      this.rows = this.apiService.sortTextDesc('cashGrantAmt', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('cashGrantAmt', this.rows)
    }
    this.sortedDescCashGrantAmt = !this.sortedDescCashGrantAmt
  }

  onViewGrantDetails(row: any) {
    //Grant Details Route
    this.router.navigateByUrl('app/search/grants/donors/' + row['donorRecipientMappingId'] + '/recipients/' + row['recipientId'] + '/details');
  }

}
